export default __webpack_public_path__ + "static/media/person-1.3b0f417e.png";